import React from 'react';

const ProjectThreeDetails = () => {
    return (
        <div>
            
        </div>
    );
};

export default ProjectThreeDetails;